<template>
    <div class="fill-height" style="position: relative;">
        <template v-if="loading && products.length === 0">
            <slot name="loading">
                <v-progress-circular
                    style="position: fixed; top: 50vh; left: 50vw; transform: translate(-50%, -50%);"
                    indeterminate
                    size="60"
                    width="3"
                    color="dark">
                </v-progress-circular>
            </slot>
        </template>
        <template v-else-if="products.length === 0">
            <slot name="empty"/>
        </template>
        <template v-else>
            <v-row
                class="px-1"
                :class="{'flex-nowrap overflow-x-auto hide-scrollbar': row}"
                no-gutters
            >
                <v-col
                    v-for="product in products"
                    :key="product.id"
                    class="pa-1"
                    v-bind="sizes"
                >
                    <slot :product="product">
                        <product-card :product="product"/>
                    </slot>
                </v-col>
            </v-row>
            <v-row v-if="$slots.pagination" class="mt-4 px-4 px-sm-12" style="margin-bottom: 72px" no-gutters>
                <v-col>
                    <slot name="pagination"/>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script>
import ProductCard from "@/components/catalog/ProductCard.vue";

export default {
    name: "ProductList",
    components: {ProductCard},
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        products: {
            type: Array,
            default: () => []
        },
        row: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        sizes() {
            if (this.row) {
                return {
                    "cols": "3",
                    "sm": "3",
                    "md": "3",
                    "lg": "2",
                }
            } else {
                return {
                    "cols": "6",
                    "sm": "6",
                    "md": "4",
                    "lg": "3"
                }
            }
        }
    }
}
</script>

<style scoped>

</style>